// 텍스트 데이터 배열, 필요한 부분은 알아서 수정하길 바람.

export const welcomekr = [
  "환영합니다",
  "현재 본 웹 사이트는 PC 환경에서 정상작동 합니다.",
];

export const welcomeen = [
  "Welcome",
  "Currently, this website works fine in a PC environment.",
];

export const iamkr = ["저는."];

export const iamen = ["I am."];

export const identitykr = [
  "브랜드. GYEONG",
  "'GYEONG'이라는 브랜딩과 닉네임은 저의 이름중 공경함을 뜻하는 '경(敬)'을 따서 지었습니다.",
  "로고는 'GYEONG'의 앞뒤 글자인 두 개의 G를 형상화 하여 제작했으며,",
  "로고의 자세한 의미는 아래 섹션에서 확인하실 수 있습니다.",
  "디자인에 공감을 더하다.",
  "저는 의미를 더하고 공감대를 형성하는 작품을 제작하는 아티스트 입니다.",
  "또한, 2D 및 3D 디자인과 여러 분야들을 다루는 디자이너 입니다.",
];

export const identityen = [
  "Brand. GYEONG",
  "The nickname 'GYEONG' was born after my name, '경(敬)' which means respect.",
  "The logo has two Gs, the front and back letters in 'GYEONG'.",
  "The nickname is embodied and can be found in the section below.",
  "Add empathy to the design.",
  "I am artist who produces works that add meaning and build rapport.",
  "also, I am a designer who deals with 2D and 3D design and many other things.",
];

export const keywordkr = [
  "주요 키워드",
  "작품을 제작하면서 제가 추구하는 방향이나, 생각 등을 키워드로 정리하였습니다",
  "붉은 키워드는 프로그램이나 범주의 큰 묶음으로 표시하였습니다.",
];

export const keyworden = [
  "Main Keywords",
  "While producing the work, I organized the direction and thoughts that I pursue into keywords.",
  "The red keyword is marked as a large bundle of programs or categories.",
];

export const subkeywordkr = [
  "포토샵",
  "포스터",
  "카드 뉴스",
  "실용성",
  "2D 그래픽",
  "3ds Max",
  "3D 그래픽",
  "모델링",
  "사물",
  "캐릭터",
  "추상적인",
  "Vray",
  "디자인",
  "편집디자인",
  "제품디자인",
  "의미",
  "창의적인",
  "생산",
  "간단함",
  "비주얼 스튜디오 코드",
  "웹 사이트",
  "개발",
  "성장",
  "도전",
  "애프터 이펙트",
  "편집",
  "애니메이션",
  "일러스트레이터",
  "직관적인",
  "레이아웃",
];

export const subkeyworden = [
  "Photoshop",
  "Poster",
  "Card News",
  "Practicality",
  "2D Graphic",
  "3ds Max",
  "3D Graphic",
  "Modeling",
  "Object",
  "Character",
  "Abstract",
  "Vray",
  "Design",
  "Editing Design",
  "Product Design",
  "Meaning",
  "Creative",
  "Produce",
  "Simple",
  "VSCode",
  "Web Site",
  "Develope",
  "Growth",
  "Challenge",
  "After Effects",
  "Editing",
  "Animation",
  "Illustrator",
  "Intuitive",
  "Layout",
];

// 작품 데이터 배열, 필요한 부분은 알아서 수정하길 바람.

export const art2dtitlekr = ["라이프 세이브스 카드 뉴스"];

export const art2dtitleen = ["Life Saves Card News"];

export const contact = ["Contact here"];
